import React from 'react';
import classnames from 'classnames';
import { Love as LoveControl, Comment as CommentControl, Fave as FaveControl, } from './OverlayControls';
import { LoveHeart } from '../../../../LoveMeter';
import s from './Overlay.scss';
export var MobileOverlayContent = function (_a) {
    var deviation = _a.deviation, showLoveControl = _a.showLoveControl, showCommentControl = _a.showCommentControl, showFaveControl = _a.showFaveControl, isLoveInProgress = _a.isLoveInProgress, className = _a.className, children = _a.children;
    return (React.createElement("div", { className: classnames(s['mobile-root'], isLoveInProgress && s['love-in-progress'], className) },
        children,
        React.createElement("div", { className: s['controls-bottom'] },
            showFaveControl && (React.createElement(FaveControl, { deviation: deviation, className: s['hide-in-love'] })),
            showLoveControl && (React.createElement(LoveControl, { deviation: deviation, statClassName: s['hide-in-love'], orientation: "horizontal" })),
            showCommentControl && (React.createElement(CommentControl, { deviation: deviation, className: s['hide-in-love'] }))),
        showLoveControl && React.createElement(LoveHeart, null)));
};
MobileOverlayContent.displayName = 'MobileOverlayContent';
export default MobileOverlayContent;
//# sourceMappingURL=MobileOverlayContent.js.map